import styled from 'styled-components';

export default comp => styled(comp)`
  .block-content_sidebar {
    .sidebar {
      .block-content_two {
        .column {
          @media (min-width: ${props => props.theme.breakpoints.desktop}) {
            width: 50%;
          }

          &:first-child {
            padding-bottom: 0.5rem;

            @media (max-width: ${props => props.theme.breakpoints.desktop}) {
              > * {
                &:first-child {
                  margin-bottom: 0;
                }

                &:nth-child(2) {
                  margin-top: 0;
                }
              }
            }

            @media (min-width: ${props => props.theme.breakpoints.desktop}) {
              padding-right: 1rem;
              padding-bottom: 0;
            }

            a {
              sup {
                border: none;
              }
            }
          }

          &:nth-child(2) {
            a {
              color: ${props => props.theme.colors.grey1};
              transition: all 0.2s ease-in-out;

              &:hover,
              &:active,
              &:focus {
                color: ${props => props.theme.colors.vmfBlue};
              }
            }
          }
        }
      }
    }
  }

  p {
    a {
      white-space: nowrap;
    }
  }

`;
